export type TourScreen = 'discover' | 'checkin' | 'event' | 'play' | 'consent' | 'dashboard';

export const tourSteps: Array<{
  screen: TourScreen;
  label: string;
  title: string;
  description: string;
  details: string[];
}> = [
  {
    screen: 'discover',
    label: 'Discover',
    title: 'Find what’s on near you.',
    description:
      'Browse an event feed with dates, cities, categories and filters. No account needed just to look around.',
    details: ['Search & filters', 'City-level location'],
  },
  {
    screen: 'checkin',
    label: 'Arrive',
    title: 'Scan the code. You’re in.',
    description:
      'Check in with the event’s QR code, or open a link from a creator you follow. Optional, and never continuous GPS tracking.',
    details: ['QR check-in', 'Creator links'],
  },
  {
    screen: 'event',
    label: 'Explore',
    title: 'Everything about the event.',
    description: 'Organizer, description, how to get there and every active brand action, all on one page.',
    details: ['Organizer', 'Getting there', 'Active actions'],
  },
  {
    screen: 'play',
    label: 'Play',
    title: 'Quick questions, honest reasons.',
    description: 'Play a quiz, a poll or a photo mission. Every question tells you why it’s being asked.',
    details: ['Rules first', 'Why we ask'],
  },
  {
    screen: 'consent',
    label: 'Choose',
    title: 'Your data, your call.',
    description:
      'Contact from a brand is a separate choice and never pre-ticked. Saying no doesn’t stop you from taking part.',
    details: ['Never pre-ticked', 'Separate choices'],
  },
  {
    screen: 'dashboard',
    label: 'Get rewarded',
    title: 'Confirmed. Fair. Notified.',
    description:
      'You get instant confirmation. Winners are chosen by rules set in advance, and you hear about it in the app.',
    details: ['Fixed draw rules', 'Entries & prizes in one place'],
  },
];
